"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = __importDefault(require("lodash"));
const Url_1 = __importDefault(require("../../Utils/Url"));
const Services_1 = __importDefault(require("../../Services"));
const Loader_1 = require("../../Utils/Loader");
const Delay_1 = require("../../Utils/Delay");
const Content_1 = __importDefault(require("../../templates/Article/Content"));
const path_1 = __importDefault(require("path"));
const ArticleSearchService = {
    addTOHistory: true,
    isChangedFilters: false,
    oldParams: {},
    isSorted: false,
    withoutPageLoader: false,
    container: '.js-search-articles-container',
    init: function () {
        const functions = [
            this.onLoadContent,
            this.initFilterControls,
            this.initPagination,
            this.initSortOptions,
            this.preventSortOptionAction,
            this.initFilterSubmit,
            this.initUrlChange,
            this.initClearButton,
        ], self = this;
        for (let i = 0; i < functions.length; ++i) {
            try {
                functions[i].bind(self)();
            }
            catch (e) {
                console.warn(e);
            }
        }
    },
    setOldParams: function (oldParams) {
        if (lodash_1.default.has(oldParams, 'q')) {
            lodash_1.default.set(oldParams, 'q', encodeURI(decodeURI(lodash_1.default.get(oldParams, 'q'))));
        }
        this.oldParams = oldParams;
    },
    onLoadContent: function () {
        const $this = this;
        $this.withoutPageLoader = true;
        $this.url = new Url_1.default(Services_1.default.URL.fullWithoutOriginAndHash());
        $this.setOldParams($this.url.getParams());
        (0, Delay_1.delay)().time(1000).handler(() => {
            $this.fetchData(true, false, $this.initStickySideBar);
        }).fire();
    },
    toggleLoader: function () {
        const filterButton = $(document).find('.js-filter-article-submit');
        if (filterButton.length > 0 && filterButton.hasClass('loading')) {
            filterButton.removeClass('loading').prop('disabled', false);
            (0, Loader_1.loader)().unblock('body');
            return;
        }
        filterButton.addClass('loading').prop('disabled', true);
        (0, Loader_1.loader)().block('body', {
            state: 'danger',
            message: 'کمی صبر کنید...',
            opacity: 0.5,
        });
    },
    initStickySideBar: function () {
        const sidebar = $(document).find('.js-sticky-sidebar-filters');
        if (sidebar.length > 0 && !sidebar.hasClass('dot-loader-hide')) {
            sidebar.delay(500).addClass('dot-loader-hide');
        }
    },
    reLoadContentLoader: function (data, callback, delay = 700) {
        const content = $(document).find(`${this.container} .article-items-wrapper`);
        const loader = content.children(`.dot-loader, dot-loader-sn`);
        if (loader.length > 0) {
            content.addClass('dot-loader-hide');
        }
        content.animate({ 'opacity': 0 }, delay, function () {
            content.removeClass('dot-loader-wrapper').html(data).animate({ 'opacity': 1 }, delay, callback);
        });
    },
    preventSortOptionAction: function () {
        const $this = this;
        $(document).find(`${this.container} .js-sort-options .js-sort-option`).each(function () {
            if ($(this).attr('data-ah-tab-active') === 'true') {
                $this.isSorted = $(this).data('action') !== 'latest';
                $(this).attr('data-prevent-action', 'true');
            }
            else {
                $(this).attr('data-prevent-action', 'false');
            }
        });
    },
    initSortOptions: function () {
        const $this = this;
        const sort_options_query = `${this.container} .js-sort-options .js-sort-option`;
        const sort_options_elems = $(document).find(sort_options_query);
        sort_options_elems.on('click mousedown', function (e) {
            try {
                if (e.type === 'mousedown' && $(this).attr('data-ah-tab-active') === 'true') {
                    $(this).attr('data-prevent-action', 'true');
                    return;
                }
                if (e.type === 'click') {
                    if ($(this).attr('data-prevent-action') === 'true') {
                        return;
                    }
                    $this.preventSortOptionAction();
                    $this.getArticlesForFilters();
                }
            }
            catch (e) {
                console.warn(e);
            }
        });
    },
    initFilterSubmit: function () {
        const $this = this;
        $(document).on('click', '.js-filter-article-submit', function (e) {
            try {
                $this.getArticlesForFilters(1, true);
            }
            catch (e) {
                console.error(e);
            }
        });
    },
    getFilterByCategory: function () {
        let checkboxParams = {};
        $(`${this.container} .filter-article .js-filter-options .js-filter-category-items input:checked`).each(function () {
            let name = $(this).attr('name');
            if (name.slice(-2) === '[]') {
                name = $(this).attr('name').slice(0, -2);
                if (typeof checkboxParams[name] === 'undefined') {
                    checkboxParams[name] = [];
                }
                checkboxParams[name].push($(this).val());
            }
            else {
                checkboxParams[name] = $(this).val();
            }
        });
        return checkboxParams;
    },
    initClearButton: function () {
        const $this = this;
        const $clearButton = $(document).find(`${$this.container} .filter-article .js-clear-filters`);
        if ($this.isSorted || ($(document).find(`${$this.container} .filter-article input[type=checkbox]:checked`).length > 0)) {
            $clearButton.fadeIn(500);
        }
        else {
            $clearButton.fadeOut(500);
        }
    },
    initFilterControls: function () {
        const $this = this;
        let timeoutID = null;
        $(document).on('submit', `${$this.container} .filter-article .widget-search form`, function (e) {
            e.preventDefault();
            $this.getArticlesForFilters(1, true);
        });
        $(document).on('click', `${$this.container} .filter-article .js-clear-filters`, function (e) {
            e.preventDefault();
            $(this).closest('.filter-article').find('input[type=checkbox]').prop('checked', false);
            $(document).find(`${$this.container} .js-sort-options .js-sort-option`)
                .removeAttr('data-ah-tab-active')
                .parent().children(`.js-sort-option[data-action='latest']`)
                .attr('data-ah-tab-active', 'true');
            $this.queryRemoved = false;
            $this.isSorted = false;
            $this.preventSortOptionAction();
            $this.getArticlesForFilters(1, true);
        });
        $(document).on('change, click', `${$this.container} .filter-article input[type=checkbox]`, function () {
            $this.initPreventDuplicateRequest();
        });
        $(document).on('keyup', `${$this.container} .filter-article .widget-search input[type=text]`, function () {
            clearTimeout(timeoutID);
            timeoutID = setTimeout(() => $this.initPreventDuplicateRequest(), 500);
        });
    },
    initPreventDuplicateRequest: function (page = undefined) {
        var _a;
        let check;
        this.initialURLByFilters(page || ((_a = this.oldParams) === null || _a === void 0 ? void 0 : _a.page) || undefined, true);
        const old = this.oldParams;
        const now = this.url.getParams();
        if ((check = lodash_1.default.isEqual(old, now))) {
            $('.js-filter-article-submit').addClass('disabled').prop('disabled', true);
        }
        else {
            $('.js-filter-article-submit').removeClass('disabled').prop('disabled', false);
        }
        return check;
    },
    initialURLByFilters: function (page, validate) {
        const $this = this;
        let val, input_value;
        $this.url = new Url_1.default(Services_1.default.URL.path());
        // Filter By {categories}
        let checkboxParams = lodash_1.default.assign({}, $this.getFilterByCategory());
        if (!lodash_1.default.isEmpty(checkboxParams)) {
            $this.url.setParams(checkboxParams);
        }
        // Filter By {query search}
        const searchInput = $(`${$this.container} .filter-article .widget-search input[name=q]`);
        const url_queryString = new Url_1.default(Services_1.default.URL.queryString());
        if (validate && (val = url_queryString.getParam('q'))) {
            if (!Services_1.default.isEmpty(input_value = searchInput.val())) {
                val = input_value;
            }
            $this.url.setParam('q', decodeURI(val));
        }
        else if (((val = searchInput.val()) || (!$this.queryRemoved && url_queryString.getParam('q')))) {
            $this.url.setParam('q', val);
            !validate && searchInput.val('');
        }
        else {
            $this.queryRemoved = false;
        }
        // Filter By {products has selling stock}
        const has_selling_stock = $(`${$this.container} .filter-article input[name=has_selling_stock]:checked`);
        if (has_selling_stock.length > 0) {
            $this.url.setParam('has_selling_stock', 1);
        }
        // Sorting By {latest || oldest || cheapest || most_expensive}
        const sort_item = $(`${$this.container} .js-sort-options .js-sort-option[data-ah-tab-active=true]`).data('action');
        if (sort_item) {
            $this.url.setParam('sort_by', sort_item);
        }
        // Set Pagination Number
        if (page) {
            $this.url.setParam('page', page);
        }
    },
    getArticlesForFilters: function (page, scrollToTop) {
        const $this = this;
        if (this.initPreventDuplicateRequest(page)) {
            return;
        }
        $this.initialURLByFilters(page);
        $this.initClearButton();
        $this.fetchData(scrollToTop, undefined);
    },
    initUrlChange: function () {
        const $this = this;
        window.onpopstate = function () {
            const url = new Url_1.default(window.location);
            let pageNumber = undefined;
            $this.addTOHistory = false;
            const sort_options = $(document).find(`${$this.container} .js-sort-options`);
            const courseSearchInput = $(document).find(`${$this.container} .filter-article .widget-search input[name=q]`);
            $(`${$this.container} .filter-article input[type=checkbox]:checked`).prop("checked", false);
            sort_options.find('.js-sort-option').removeAttr('data-ah-tab-active');
            courseSearchInput.val('');
            const flags = ['has_selling_stock'];
            let price_range = [];
            $.each(url.getParams(), function (name, value) {
                name = name.toString();
                if (name === 'sort_by') {
                    sort_options.find(`.js-sort-option[data-action='${value}']`).attr('data-ah-tab-active', 'true');
                }
                else if (name === 'page') {
                    pageNumber = value;
                }
                else if (name === 'price[min]') {
                    $(document).find('#slider-non-linear-step').data('filter-min', value);
                    price_range.push(value);
                }
                else if (name === 'price[max]') {
                    $(document).find('#slider-non-linear-step').data('filter-max', value);
                    price_range.push(value);
                }
                else if (name === 'q') {
                    courseSearchInput.val(value);
                }
                else if (flags.indexOf(name) >= 0) {
                    $(`${$this.container} .filter-article input[type=checkbox][name=${name}]`).prop('checked', true);
                }
                else {
                    let elName = name.substring(0, name.lastIndexOf('['));
                    $(document).find(`${$this.container} .filter-article .js-filter-options input[type=checkbox][name='${elName}[]'][value='${value}']`).prop("checked", true);
                }
            });
            if (price_range) {
                $this.initFilterRange(true, price_range);
            }
            $this.getArticlesForFilters(pageNumber, true);
            $this.addTOHistory = true;
        };
    },
    initPagination: function () {
        const $this = this;
        $(document).on('click', `${$this.container} .pagination-cm a.pagination-item`, function (e) {
            e.preventDefault();
            let page;
            if ((page = lodash_1.default.toNumber($(this).data('page'))) && !isNaN(page)) {
                $this.getArticlesForFilters(page, true);
            }
        });
    },
    fetchData: function (scrollToTop, url, callback) {
        const $this = this;
        $this.setOldParams($this.url.getParams());
        $.ajax({
            url: path_1.default.join('/web/api/', url || $this.url.getUrl()),
            type: "GET",
            dataType: "json",
            beforeSend: function (jqxhr) {
                if ($this.jqxhr) {
                    $this.jqxhr.abort();
                }
                !$this.withoutPageLoader && $this.toggleLoader();
                if ($this.addTOHistory) {
                    $this.url.update();
                }
                $this.jqxhr = jqxhr;
            },
            success: function (response) {
                $this.reLoadContentLoader(new Content_1.default(response).render(), function () {
                    !$this.withoutPageLoader && $this.toggleLoader();
                    $this.withoutPageLoader = false;
                    lodash_1.default.isFunction(callback) && callback();
                    $this.initPreventDuplicateRequest();
                    Services_1.default.initTooltips();
                    if (scrollToTop) {
                        Services_1.default.scrollWindowToList();
                    }
                });
            },
            error: function (data) {
                !$this.withoutPageLoader && $this.toggleLoader();
                if (scrollToTop) {
                    Services_1.default.scrollWindowToList();
                }
            },
            complete: function () {
                $(".tooltip").tooltip("hide");
            }
        });
    }
};
exports.default = ArticleSearchService;
